module.exports = __webpack_public_path__ + "static/media/clockout.d272d6ee.png";